import NovaSolicitacaoPopup from '../NovaSolicitacaoPopup';
import { SolicitacaoController, TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import Util from '@tekvue/assets/utils/Util';
import Field from '@tekvue/assets/interfaces/Field';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { INovaSolicitacao } from '../interfaces';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import DialogUtils from '@tekvue/assets/utils/DialogUtils';
import Messages from '@/assets/ts/utils/Messages';

@Component({
  name: 'NovaSolicitacaoOcupacaoSalario',
})
export default class NovaSolicitacaoOcupacaoSalario extends Vue implements INovaSolicitacao {
  // #region [ DATA ]
  TP_SOLICITACAO = TiposSolicitacao.TP_SOLI_MOVIM_OCUPACAO_SALARIO;

  main: NovaSolicitacaoPopup | null = null;

  public get fields(): Field[] {
    return this.main ? [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NRTPMOVTRANSFM_HIST',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.main.transferencias,
        readonly: true
      },
      {
        name: 'NRMOTIVOTRANSF_HIST',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.main.motivosTransferencia,
        readonly: true,
      },
      {
        name: 'NRESTRUTURAM_LEGAL_HIST',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasLegais,
        readonly: true
      },
      {
        name: 'NRESTRUTURAM_GEREN_HIST',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasGerenciais,
        readonly: true
      },
      {
        name: 'NROCUPACAOM_HIST',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.main.ocupacoes,
        readonly: true,
      },
      {
        name: 'NRMOTIVOOCUPA_HIST',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.main.motivosOcupa,
        readonly: true,
      },
      {
        name: 'NRTPMODALIDSAL_HIST',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO_HIST',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        name: 'VRSALARIOATUAL_HIST',
        label: 'Salário Atual',
        type: 'text',
        size: 4,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO_HIST',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 4,
        readonly: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA_HIST',
        label: 'Tipo de Alteração',
        size: 4,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.main.tiposAlteraSal,
        readonly: true,
      },
      {
        name: 'DTADMISSAOVINC',
        label: 'Data de Admissão',
        size: 4,
        type: 'date',
        readonly: true,
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasLegais,
      },
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasGerenciais,
      },
      {
        name: 'NRTPMOVTRANSFM',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        required: this.main.isSoliMovimentRequired,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.main.transferencias,
      },
      {
        name: 'NRMOTIVOTRANSF',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.main.motivosTransferencia,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.main.ocupacoes,
        required: true,
      },
      {
        name: 'NRMOTIVOOCUPA',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.main.motivosOcupa,
        required: true,
      },
      {
        name: 'NRTPMODALIDSAL',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        required: true,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        required: true,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        name: 'VRSALARIO',
        label: 'Salário',
        type: 'number',
        size: 4,
        required: this.main.isSoliSalarioRequired,
      },
      {
        name: 'PERCALTERA',
        label: 'Percentual Real(%)',
        type: 'text',
        size: 6,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 4,
        required: this.main.isSoliSalarioRequired,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA',
        label: 'Tipo de Alteração',
        size: 4,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.main.tiposAlteraSal,
        required: this.main.isSoliSalarioRequired,
      },
      {
        name: 'DTINIMOVIMENT',
        label: 'Data de Início',
        type: 'date',
        size: 6,
        month: true,
        required: true,
        onInput: () => {
          this.main.validaDataAnteriorCompetencia('DTINIMOVIMENT');
        },        
        minDate: this.main.minDtInitMovimentMovimentacao,
        maxDate: this.main.maxDtInitMovimentMovimentacao,
        hint: 'Obs.: deve ser posterior à data de admissão do vínculo.',
        persistentHint: true,
      },
      {
        name: 'DTFIMMOVIMENT',
        label: 'Data de Fim',
        type: 'date',
        size: 6,
      },
      {
        name: 'DSOBSALTESALARIO',
        label: 'Justificativa',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      },
    ] : [];
  }

  // #region [ WATCHERS ]
  @Watch('fields')
  private fieldsOnChange() {
    this.main.injectFields(this);
  }

  // #region [ ACTIONS ]
  public onAdvance(): void | Promise<void> {
    this.setMovimentacaoOcupacaoSalarioFields();
  };

  public get onSaveValidation() {
    return this.onSaveMovimentacaoOcupacaoSalarioValidations;
  }

  public get afterAdvance() {
    return this.main.afterAdvanceActionHistoric;
  }

  // #region [ METHODS ]
  private async setMovimentacaoOcupacaoSalarioFields() {
    if(this.main.isEdit) {
      this.main.preencherCamposEdit();
    } else {
      await this.main.ocupacaoAdvancedValidations();
    }

    this.main.loading = true;
    try {
      // Ajustar query
      const [previouMovim, ocupacaoPrevious] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.main.row.NRVINCULOM, 2),
        this.main.getPreviousDataSolicitation(),
        this.main.loadTiposTransferencia(),
        this.main.loadTransferencias(),
        this.main.loadMotivosTransferencia(),
        this.main.loadEstruturasLegais(),
        this.main.loadEstruturasGerenciais(),
        this.main.loadOcupacoes(),
        this.main.loadMotivosOcupa(),
        this.main.loadTipoAlteraSal(),
        this.main.loadModalidadeSal(),
        this.main.loadUltimoSalario()
      ]);

      this.main.setDefaultRowSalario();
      this.main.setDefaultRowTransferenciaLegal(previouMovim.LEGAL, previouMovim.GERENCIAL);
      this.main.setDefaultRowOcupacao(ocupacaoPrevious);

      const defaultRowOcupacaoCopy = Util.deepCopy(this.main.defaultRowOcupacao);
      const defaultRowSalarioCopy = Util.deepCopy(this.main.defaultRowSalario);
      const defaultRowTransferenciaLegalCopy = Util.deepCopy(this.main.defaultRowTransferenciaLegal);
      this.main.row = {...this.main.row, ...defaultRowOcupacaoCopy, ...defaultRowSalarioCopy, ...defaultRowTransferenciaLegalCopy};

    } finally {
      this.main.loading = false;
    }
  }

  private async onSaveMovimentacaoOcupacaoSalarioValidations(): Promise<boolean> {

    if(!(await this.main.validateSalario())) {
      return false;
    }

    let validateEstrut = () => {};

    //Validações especificas da estrututra legal e gerencial
    if(this.main.row.NRESTRUTLEGAL && this.main.row.NRESTRUTGEREN) {
      validateEstrut = this.main.validationsEstrutLegal;
    }

    if(this.main.row.NRESTRUTGEREN && !this.main.row.NRESTRUTLEGAL) {
      validateEstrut = this.main.validationsEstrutGeren;
    }

    const [solicitacoes, folhaCalc] = await Promise.all([
      NovaSolicitacaoController.getSolicitacoesDia(this.main.row, this.main.isEdit),
      SolicitacaoController.getFolhaFechada(this.main.row.NRVINCULOM, this.main.row.DTINIMOVIMENT),
      validateEstrut(),
    ]);

    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.main.row.DTINIMOVIMENT = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    }

    if(folhaCalc && folhaCalc.length) {
      await DialogUtils.show('Aviso', Messages.SOLIC_FECHA_FOLHA, () => {}, () => {}, false, true);
      return false;
    }


    if(this.main.row.VRSALARIO == this.main.dadosUltimoSal.VRSALARIO) {
      this.main.clearInputsSalarioOfRow();
    }

    return true;
  }
}